/**
 Validates org numbers from Austria
 */
export const validateAustriaOrgNumber = (number: string) => {
  const austriaOrgNumberRegex = /^\d{1,6}[A-Za-z]\d{0,3}$/g;
  return austriaOrgNumberRegex.test(number);
};
